import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import Field, { describedBy } from "@/components/Field";
import FormDialog from "@/components/FormDialog";
import { createOrganization } from "../../utils";

interface Props {
  open: boolean;
  onClose(created?: Organization): void;
}

const CreateOrganizationModal: React.FC<Props> = ({ open, onClose }) => {
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
      setSubmitted(false);
      setError(null);
    }
  }, [open]);

  const handleSubmit = async () => {
    setSubmitted(true);
    if (!name.trim()) return;
    setSubmitting(true);
    setError(null);
    try {
      onClose(await createOrganization(name.trim()));
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  const nameError = submitted && !name.trim() ? "Vul een naam in" : null;

  return (
    <FormDialog
      open={open}
      onOpenChange={(next) => !next && onClose()}
      title="Nieuwe organisatie"
      submitLabel="Aanmaken"
      submitting={submitting}
      error={error}
      onSubmit={handleSubmit}
    >
      <Field id="organization-name" label="Naam" error={nameError}>
        <Input
          id="organization-name"
          value={name}
          aria-invalid={nameError != null}
          aria-describedby={describedBy("organization-name")}
          onChange={(e) => setName(e.target.value)}
        />
      </Field>
    </FormDialog>
  );
};

export default CreateOrganizationModal;
